export const dashboardSliceName = "dashboard"
